import { createStyles } from "@mantine/core";
import { pxToRem } from "theme";

export const useStyles = createStyles((theme) => ({
  icon: {
    padding: pxToRem[6],
    display: "flex",
    height: pxToRem[40],
    width: pxToRem[40],
    alignItems: "center",
    justifyContent: "center",
    background: theme.other.primary[5],
    borderRadius: "50%",
  },
  text: { width: "80%" },
}));
